import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HashLink as Link } from 'react-router-hash-link';

import immoquipoLogo from '../../images/immoquipo-logo.png';

export default class Header extends Component {
  static propTypes = {
    onContact: PropTypes.func,
  };

  render() {
    return (
      <div className="common-header">
        <div className="header-wrapper">
          <h1 className="immoquipo-logo"><img className="logo" src={immoquipoLogo} alt="logo" /> <span className="app-name">immoquipo</span></h1>
          <div className="right">
            <Link smooth className="link" to="#le-concept">Concept</Link>
            <Link smooth className="link" to="#comment-ca-marche">Comment ça marche</Link>
            <p className="link" onClick={this.props.onContact}>Contactez-nous</p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/Header.js